<template>
  <section class="device-runtime-panel">
    <div class="sheBeiLiuCheng"></div>
    <div class="yuanShuiXiang"></div>

    <device-metric-node
      class="yuanShuiLiang zhuShiZuo"
      :protocol="protocol"
      metric="rawWaterTotal"
      label="原水量"
      unit="m³"
    />
    <device-status-node
      class="zongJinShuiFa"
      :protocol="protocol"
      node="totalInletValve"
    />
    <device-status-node
      class="yuanShuiBang"
      :protocol="protocol"
      node="rawWaterPump"
    />
    <device-metric-node
      class="jinShuiYaLi zhuShiZuo"
      :protocol="protocol"
      metric="inletPressure"
      label="进水压力"
      unit="Mpa"
    />
    <device-metric-node
      class="jinShuiLiuLiang zhuShiZuo"
      :protocol="protocol"
      metric="inletFlow"
      label="进水流量"
      unit="m³/H"
    />
    <device-status-node
      class="jinShuiFa"
      :protocol="protocol"
      node="inletValve"
    />
    <device-status-node
      class="gaoYaFa"
      :protocol="protocol"
      node="highPressurePump"
    />
    <device-metric-node
      class="moQianYaLi zhuShiXia"
      :protocol="protocol"
      metric="membranePressure"
      label="膜前压力"
      unit="Mpa"
    />
    <device-status-node
      class="nongShuiFa"
      :protocol="protocol"
      node="concentrateValve"
    />
    <device-metric-node
      class="chunShuiLiang zhuShiZuo"
      :protocol="protocol"
      metric="pureWaterTotal"
      label="纯水量"
      unit="m³"
    />
    <device-metric-node
      class="chunShuiLiuLiang zhuShiXia"
      :protocol="protocol"
      metric="pureWaterFlow"
      label="纯水流量"
      unit="m³/H"
    />
    <div class="chunShuiXiang"></div>
    <device-status-node
      class="gongShuiBang"
      :protocol="protocol"
      node="supplyPump"
    />
    <device-metric-node
      class="gongShuiYaLi zhuShiXia"
      :protocol="protocol"
      metric="supplyPressure"
      label="供水压力"
      unit="Mpa"
    />
    <device-metric-node
      class="gongShuiLiuLiang zhuShiXia"
      :protocol="protocol"
      metric="supplyFlow"
      label="供水流量"
      unit="m³/H"
    />
    <device-metric-node
      class="shiShiWenDu"
      :protocol="protocol"
      metric="temperature"
      label="实时温度"
      unit="℃"
      variant="temperature"
    />
  </section>
</template>

<script>
import DeviceMetricNode from "./DeviceMetricNode.vue";
import DeviceStatusNode from "./DeviceStatusNode.vue";

export default {
  name: "DeviceRuntimePanel",
  components: { DeviceMetricNode, DeviceStatusNode },
  props: {
    protocol: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style lang="scss" scoped>
.sheBeiLiuCheng,
.yuanShuiXiang,
.zongJinShuiFa,
.yuanShuiBang,
.yuanShuiLiang,
.jinShuiYaLi,
.jinShuiLiuLiang,
.jinShuiFa,
.gaoYaFa,
.moQianYaLi,
.nongShuiFa,
.chunShuiLiang,
.chunShuiLiuLiang,
.chunShuiXiang,
.gongShuiBang,
.gongShuiYaLi,
.gongShuiLiuLiang,
.shiShiWenDu {
  position: absolute;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.sheBeiLiuCheng {
  top: 190px;
  left: 28px;
  width: 1864px;
  height: 230px;
  background-image: url("/images/dashboard/shebei1.png") !important;
}

.yuanShuiXiang {
  top: 190px;
  left: 28px;
  width: 86px;
  height: 184px;
  background-image: url("/images/dashboard/Group1.webp") !important;
}

.zongJinShuiFa { top: 290px; left: 168px; }
.yuanShuiBang { top: 275px; left: 258px; }
.jinShuiFa { top: 226px; left: 837px; }
.gaoYaFa { top: 222px; left: 922px; }
.nongShuiFa { top: 288px; left: 1250px; }
.gongShuiBang { top: 272px; left: 1502px; }

.zongJinShuiFa,
.yuanShuiBang,
.jinShuiFa,
.gaoYaFa,
.nongShuiFa,
.gongShuiBang {
  width: 28px;
  height: 28px;
}

.jinShuiYaLi { top: 230px; left: 352px; width: 100px; height: 55px; }
.jinShuiLiuLiang { top: 301px; left: 352px; width: 100px; height: 55px; }
.yuanShuiLiang { top: 230px; left: 130px; width: 100px; height: 55px; }
.moQianYaLi { top: 282px; left: 980px; width: 100px; height: 55px; }
.chunShuiLiang { top: 214px; left: 986px; width: 100px; height: 55px; }
.chunShuiLiuLiang { top: 146px; left: 1250px; width: 100px; height: 55px; }
.gongShuiYaLi { top: 282px; left: 1576px; width: 100px; height: 55px; }
.gongShuiLiuLiang { top: 282px; left: 1692px; width: 100px; height: 55px; }

.chunShuiXiang {
  top: 206px;
  left: 1360px;
  width: 86px;
  height: 184px;
  background-image: url("/images/dashboard/Group2.webp") !important;
}

.shiShiWenDu {
  top: 124px;
  left: 1660px;
  width: 170px;
  height: 72px;
  cursor: pointer;
  background-image: url("/images/dashboard/shishiwendu.webp") !important;
}

.kaiGuan1 { background-image: url("/images/dashboard/kai.png") !important; }
.kaiGuan2 { background-image: url("/images/dashboard/guan.png") !important; }
.zhuShiZuo {
  padding-left: 15px;
  background-image: url("/images/dashboard/zhushizuo.png") !important;
}
.chunShuiLiang {
  padding-left: 8px;
  padding-right: 15px;
  background-image: url("/images/dashboard/zhushiyou.png") !important;
}
.zhuShiXia { background-image: url("/images/dashboard/zhushixia.png") !important; }
</style>
